import { useTranslation } from "next-i18next";

import Header from "../../text/header";
import styles from "../landing/landing.module.scss";
import { Search } from "../search";

const SectionWrapper = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) => {
    return <div className={`${styles.sectionWrapper} ${className}`}>{children}</div>;
};

export const HelpSearch = ({ type = "consumer" }: { type?: "consumer" | "merchant" }) => {
    const { t } = useTranslation();
    const apiEndpoint = type === "merchant" ? "/api/help/search?type=merchant" : "/api/help/search";
    const searchPagePath = type === "merchant" ? "/help-merchant/search" : "/help/search";

    return (
        <SectionWrapper className={styles.searchSection}>
            <Header renderAs="h6" title={t("help.search.title")} className={styles.helpSubTitle} />
            <Search
                placeholder={t("help.search.placeholder", "Search help")}
                apiEndpoint={apiEndpoint}
                searchPagePath={searchPagePath}
            />
        </SectionWrapper>
    );
};
